module.exports = __webpack_public_path__ + "media/images/expand-more-ee844835.svg";